import { submitUpdateBroadcast } from "../../../api/broadcast/submitUpdateBroadcast.service";
import { SUBMIT_UPDATE_BROADCAST } from "../actionTypes";

const request = () => ({ type: SUBMIT_UPDATE_BROADCAST.REQUEST });
const failure = (error) => ({ type: SUBMIT_UPDATE_BROADCAST.FAILURE, error });
const success = () => ({ type: SUBMIT_UPDATE_BROADCAST.SUCCESS });

export const SubmitUpdateBroadcast = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(request());
    return submitUpdateBroadcast(payload,id)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};